/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError, AxiosInstance } from "axios";

const refreshSubscribers: (() => void)[] = [];

export function addRefreshSubscriber(callback: () => void) {
  refreshSubscribers.push(callback);
}

export function createAxiosInterceptor(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const { response, config } = error;

      // only redirect GET requests with a 403 status code
      if (response?.status === 403 && config?.method === "get") {
        window.openToast?.({ intent: "warning", message: (response.data as any)?.message ?? "You don't have access to this page." });
        history.replaceState({}, "", "/");
        return;
      }

      // 401 handling is owned by the session service worker (service-workers/auth.ts):
      // it transparently renews the session and replays the request, or posts
      // SESSION_EXPIRED (handled in sw-register.ts) when the session is gone.
      return Promise.reject(error);
    },
  );
}
